// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"32":"HomeView","86":"CoursesView","132":"PolicyView","372":"CourseView","373":"RulesView","705":"ContactsView"}[chunkId] + "." + {"32":"e7b25939","86":"c226f884","132":"0efa3dd6","372":"37011327","373":"53e15f37","705":"945f5d52"}[chunkId] + ".css";
};